import { cn } from '@lib/utils';
import 'lineicons/dist/lineicons.css';

// Lineicons mapping for portfolio sections
const iconMap = {
  chess: 'lni lni-game-pad-modern-1',      // Game pad for chess/strategic games
  robotics: 'lni lni-gears-3',              // Gears for robotics/automation
  'social-impact': 'lni lni-heart',         // Heart for social impact
  badminton: 'lni lni-sports',              // Sports
  music: 'lni lni-music',                   // Music note
  research: 'lni lni-microscope',           // Microscope
  experience: 'lni lni-briefcase-1',        // Briefcase for experience
  academics: 'lni lni-graduation-cap-1',    // Graduation cap
  sun: 'lni lni-sun-1',                     // Sun
  moon: 'lni lni-moon-half-right-5',        // Moon
  email: 'lni lni-envelope-1',              // Email
  phone: 'lni lni-phone',                   // Phone
  github: 'lni lni-github',                 // GitHub
  linkedin: 'lni lni-linkedin',             // LinkedIn
  lichess: 'lni lni-game-pad-modern-1',     // Lichess (chess platform)
  location: 'lni lni-map-marker-1',         // Location
  clock: 'lni lni-alarm-1',                 // Clock/time
  arrow: 'lni lni-arrow-right',             // Arrow
  download: 'lni lni-download-1',           // Download
  print: 'lni lni-printer',                 // Print
  search: 'lni lni-search-1',               // Search
  cart: 'lni lni-cart-1',                   // Shopping cart
  'mobile-phone': 'lni lni-laptop-phone',   // Mobile phone/app
  laptop: 'lni lni-laptop-2',               // Laptop/computer
  tools: 'lni lni-hammer-1',                // Tools/development
  target: 'lni lni-target-user',            // Target/goals
  books: 'lni lni-books-2',                 // Books/knowledge
  robot: 'lni lni-gears-3',                 // Robot/AI (using gears)
};

const Icon = ({ name, className = 'inline-block', size = 'lg', alt = name, ...props }) => {
  const iconClasses = iconMap[name];

  if (!iconClasses) {
    console.warn(`Icon "${name}" not found in Lineicons`);
    return null;
  }

  // Size mapping for Lineicons (md uses default size, no class needed)
  const sizeClass = {
    sm: 'text-base',      // ~16px
    md: 'text-xl',        // ~20px
    lg: 'text-2xl',       // ~24px
    xl: 'text-4xl',       // ~36px
    '2xl': 'text-5xl',    // ~48px
  }[size] || 'text-xl';

  return (
    <i
      className={cn(iconClasses, sizeClass, className)}
      title={alt}
      aria-hidden="true"
      {...props}
    />
  );
};

export default Icon;
